import * as React from "react";
import { Button, Heading, List, ListItem } from "@chakra-ui/react";
import { format } from "date-fns";
import { Activity, Teammate } from "./data";

type DateTileProps = {
  date: Date;
  teammates: Array<Teammate>;
  activities: Array<Activity>;
  selected: boolean;
  disabled: boolean;
  onClick: (date: Date) => void;
};

export function DateTile(props: DateTileProps): React.ReactElement {
  const handleChange = () => {
    props.onClick(props.date);
  };

  return (
    <Button
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      onClick={handleChange}
      variant="ghost"
      minWidth={40}
      borderColor={props.selected ? "teal" : "none"}
      borderRadius={4}
      disabled={props.disabled}
      borderWidth={4}
      pt={4}
      height="100%"
    >
      <Heading size="md" mb={4}>
        {format(props.date, "MMM d")}
      </Heading>
      <Heading size="sm" color="teal">
        Teammates
      </Heading>
      <List mb={4} height={8}>
        {props.teammates.map((teammate) => (
          <ListItem key={teammate.name}>{teammate.name}</ListItem>
        ))}
      </List>
      <Heading size="sm" color="teal">
        Activities
      </Heading>
      <List mb={4}>
        {props.activities.map((activity) => (
          <ListItem key={activity.name}>{activity.name}</ListItem>
        ))}
      </List>
    </Button>
  );
}
